import React from "react";
import '../css/codescreen.css';

const CodeScreen = () => {

  return (
    <div>
      <div className="container-fluid" style={{backgroundColor:'#262335'}}> 
        <p className="text-secondary ms-2">
          salihgenc.com &gt; src &gt; components &gt; mainpage.js
        </p>
        <div className="row">
          <div className="col-1 ms-2">
            <ul className="text-secondary list-unstyled ms-4">
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>10</li>
                <li>11</li>
                <li>12</li>
                <li>13</li>
                <li>14</li>
                <li>15</li>
                <li>16</li>
                <li>17</li>
                <li>18</li>
                <li>19</li>
                <li>20</li>
                <li>21</li>
                <li>22</li>
                <li>23</li>
                <li>24</li>
                <li>25</li>
            </ul>
          </div>

          <div className="col-10">
            <h6 className="text-white d-inline">
            <span className="green">import </span>
            <span className="pink">React</span>
            <span className="text-secondary fw-bold">, </span>
            <span className="yellow">&#123;</span>
            <span className="pink"> useState </span>
            <span className="yellow">&#125; </span>
            <span className="yellow">from </span>
            <span className="orange">'react'</span>
            </h6>
            

            <span className="besinci d-block"> 
              <h6 className="text-white d-inline">
                <span className="yellow">const </span>
                <span className="blue">Selam </span>
                <span className="text-white">= </span>
                <span className="pink">() </span>
                <span className="yellow">=&gt; </span>
                <span className="pink">&#123;</span>
              </h6>
            </span>

            <span className="d-block ms-3 mt-4"> 
              <h6 className="text-white d-inline">
                <span className="yellow">const </span>
                <span className="pink">[skills</span>
                <span className="text-secondary fw-bold">, </span>
                <span className="blue">setSkills</span>
                <span className="pink">] </span>
                <span className="text-white">= </span>
                <span className="blue">useState</span>
                <span className="pink">( </span>

                <span className="blue">[</span>

                <span className="orange">'CSS'</span>
                <span className="text-secondary fw-bold">, </span>
                <span className="orange">'Boostrap'</span>
                <span className="text-secondary fw-bold">, </span>
                <span className="orange">'EcmaScript'</span>
                <span className="text-secondary fw-bold">, </span>
                <span className="orange">'React'</span>
                <span className="text-secondary fw-bold">, </span>
                <span className="orange">'SomeLove'</span>
                <span className="blue">] </span>
                <span className="pink">)</span>

              </h6>
            </span>

            <span className="d-block ms-2" style={{marginTop:'31px'}}> 
              <h6 className="text-white d-inline">
                <span className="yellow">return </span>
                <span className="pink">( </span>
              </h6>
            </span>

            <span className="d-block ms-4"> 
              <h6 className="text-white d-inline">
              <span className="blue">&lt;</span>
                <span className="green">div</span>
                <span className="blue">&gt;</span>
              </h6>
            </span>

       

            <span className="d-block ms-5"> 
              <h6 className="text-white d-inline">
                <span className="blue">&lt;</span>
                <span className="green">p </span>
                <span className="yellow">className </span>
                <span className="text-white">=</span>
                <span className="orange">"about"</span>
                <span className="blue">&gt;</span>
              </h6>
            </span>

            <span className="d-block mt-1" style={{marginLeft:'65px'}}> 
              <h6 className="text-white d-inline">
                <span className="text-secondary fw-bold">
                                  Hi, I have been dealing with web development processes for more than 2 years and trying to improve myself in the field of javascript. I am working on both frontend and backend sides of Javascript. The weight of my work is closer to the frontend. On the frontend side, I make mobile priority wep apps and websites.
                </span>
              </h6>
            </span>

            <span className="d-block ms-5"> 
              <h6 className="text-white d-inline">
              <span className="blue">&lt;/</span>
              <span className="green">p</span>
              <span className="blue">&gt;</span>
              </h6>
            </span>

            
            <span className="d-block ms-5" style={{marginTop:'32px'}}> 
            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/salihgenc/" style={{textDecoration:'none'}}>
              <h6 className="d-inline">
              <span className="blue">&lt;</span>
              <span className="green">a </span>
              <span className="yellow">href</span>
              <span className="text-white">=</span>
              <span className="orange">"https://www.linkedin.com/in/salihgenc/"</span>
              <span className="blue">&gt;</span>
              <span className="text-secondary fw-bold"> My Linkedin Page </span>
              <span className="blue">&lt;/</span>
              <span className="green">a</span>
              <span className="blue">&gt;</span>
              </h6>
            </a>
            </span>

            <span className="d-block ms-5" style={{marginTop:'30px'}}> 
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/salihgenchw" style={{textDecoration:'none'}}>
              <h6 className="d-inline">
              <span className="blue">&lt;</span>
              <span className="green">a </span>
              <span className="yellow">href</span>
              <span className="text-white">=</span>
              <span className="orange">"https://github.com/salihgenchw"</span>
              <span className="blue">&gt;</span>
              <span className="text-secondary fw-bold"> Github </span>
              <span className="blue">&lt;/</span>
              <span className="green">a</span>
              <span className="blue">&gt;</span>
              </h6>
            </a>
            </span>


            <span className="d-block ms-2" style={{marginTop:'30px'}}> 
              <h6 className="text-white d-inline">
            <span className="pink">)&#125;</span>
            <span className="text-secondary fw-bold">;</span>
              </h6>
            </span>

            <span className="d-block ms-2" style={{marginTop:'30px'}}> 
              <h6 className="text-white d-inline">
            <span className="green">export </span>
            <span className="yellow">default </span>
            <span className="blue">Selam</span>
            <span className="text-secondary fw-bold">;</span>
              </h6>
            </span>


          </div> 
        </div>
      </div>
    </div>
  );
}

export default CodeScreen;
